import { render } from "./signUpRemarkDialog.vue?vue&type=template&id=cc960c34&scoped=true"
import script from "./signUpRemarkDialog.vue?vue&type=script&lang=js"
export * from "./signUpRemarkDialog.vue?vue&type=script&lang=js"

import "./signUpRemarkDialog.vue?vue&type=style&index=0&id=cc960c34&scoped=true&lang=css"

import exportComponent from "D:\\yiban\\WebProject\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc960c34"]])

export default __exports__